import { motion } from "framer-motion";
import { Certificate, ShieldCheck, Timer } from "@phosphor-icons/react";
import { SectionHeader } from "@/components/SectionHeader";

const strengths = [
  "Experienced project support team",
  "Skilled and certified manpower",
  "Well-maintained equipment",
  "Competitive commercial terms",
  "Timely mobilization and demobilization",
  "Strong commitment to safety and quality",
  "PAN India service capability",
];

const panelInitial = { opacity: 0, y: 28 };
const panelInView = { opacity: 1, y: 0 };
const rowInitial = { opacity: 0, x: 28 };
const rowInView = { opacity: 1, x: 0 };
const viewportOnce = { once: true };

export function WhyChooseUs() {
  return (
    <section id="why-us" className="border-b border-industrial-line py-24 sm:py-32" data-testid="why-choose-us-section">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <SectionHeader eyebrow="Why Shyam / 05" title="Dependability is engineered into the process" description="Every engagement is structured around accountable coordination, safe deployment, and commercial clarity." testId="why-choose-us-header" />
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <motion.div initial={panelInitial} whileInView={panelInView} viewport={viewportOnce} className="border border-industrial-yellow bg-industrial-yellow p-8 text-industrial-black hard-shadow" data-testid="quality-commitment-panel">
            <ShieldCheck size={48} weight="fill" />
            <h3 className="mt-8 font-heading text-4xl font-bold uppercase leading-none">Safety + quality as operating discipline</h3>
            <p className="mt-5 max-w-md text-sm font-medium leading-7">Professional project support with careful planning, clear communication, and practical responsiveness across industrial sites.</p>
            <div className="mt-8 grid grid-cols-2 gap-px bg-white/20">
              <div className="bg-industrial-yellow p-4"><Certificate size={26} weight="fill" /><p className="mt-3 font-mono text-[11px] font-bold uppercase tracking-[0.16em]">Certified manpower</p></div>
              <div className="bg-industrial-yellow p-4"><Timer size={26} weight="fill" /><p className="mt-3 font-mono text-[11px] font-bold uppercase tracking-[0.16em]">On-time mobilization</p></div>
            </div>
          </motion.div>
          <div className="grid border border-industrial-line bg-industrial-line" data-testid="strengths-list">
            {strengths.map((strength, index) => (
              <motion.div key={strength} initial={rowInitial} whileInView={rowInView} viewport={viewportOnce} transition={{ delay: index * 0.06 }} className="group flex items-center gap-6 bg-white p-5 transition-colors hover:bg-industrial-surface sm:p-6" data-testid={`strength-item-${index + 1}`}>
                <span className="font-mono text-xl text-industrial-yellow">{String(index + 1).padStart(2, "0")}</span>
                <p className="font-heading text-xl font-semibold uppercase text-industrial-text transition-transform group-hover:translate-x-1 sm:text-2xl">{strength}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
